var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgEdit = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 17.535,
      height: 17.454,
      viewBox: "0 0 17.535 17.454",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_18198",
      "data-name": "Group 18198",
      transform: "translate(-7.43 -0.075)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_4526",
      "data-name": "Path 4526",
      d: "M12.238,16.746,8,17.507a.436.436,0,0,1-.544-.544Zm.87-.87L9.084,11.851,19.527,1.408l4.025,4.025Zm11.2-11.2L20.288.646a2.173,2.173,0,0,1,2.937,0l1.088,1.088A1.978,1.978,0,0,1,24.313,4.671Z",
      transform: "translate(0 0)"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_6664",
      "data-name": "Rectangle 6664",
      width: 14.685,
      height: 5.765,
      transform: "translate(9.072 11.794) rotate(-45)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_4527",
      "data-name": "Path 4527",
      d: "M21.137.646a2.173,2.173,0,0,0-2.937,0l4.025,4.025a2.173,2.173,0,0,0,0-2.937Z",
      transform: "translate(2.088 0)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_4529",
      "data-name": "Path 4529",
      d: "M6.946,16.486l4.242-.761L7.163,11.7,6.4,15.942A.436.436,0,0,0,6.946,16.486Z",
      transform: "translate(1.05 1.021)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Edit.0f7dad2b.svg";
export { ForwardRef as ReactComponent };